let instance = null;
export class SingletonCallOutData{
    constructor() {
      if (!instance) {
        instance = this;
      }
      this.callKey = '';
      this.callID = 0;
      this.callOutID = 0;
      this.callType = 0;
      this.DNIS = '';
      this.dataContact = ['', null, null, null, null];
      this.dataHeaders = null;
      this.dataKeyValue = '0:0';
      this.campName = '';
      this.engineID = 0;
      this.holdTime = 0;
      this.campID = 0;
      this.isACDTransfer = false;
      this.isQueueCall = false;
      this.phone = '';
      this.port = 0;
      this.waitingTime = 0;
      this.wrapUpTime = 0;
      this.action = '';
      this.holdCall = false;
      this.selectedPhoneItem = {};
      this.exitDispositionsMode = false;
      this.saveDispositionInDialog = false;
      this.assistedCallKey = '';
      this.assistedData1 = '';
      this.assistedData = [];
      return instance;
    }
    cleanCallData() {
      this.callKey = '';
      this.callID = 0;
      this.callOutID = 0;
      this.callType = 0;
      this.DNIS = '';
      this.dataContact = ['', null, null, null, null];
      this.dataHeaders = null;
      this.dataKeyValue = '0:0';
      this.campName = '';
      this.engineID = 0;
      this.holdTime = 0;
      this.campID = 0;
      this.isACDTransfer = false;
      this.isQueueCall = false;
      this.phone = '';
      this.port = 0;
      this.waitingTime = 0;
      this.wrapUpTime = 0;
      this.action = '';
      this.holdCall = false;
      this.selectedPhoneItem = {};
      this.exitDispositionsMode = false;
      this.saveDispositionInDialog = false;
    }
    setCallOutDataFromCall(call) {
      this.callKey = call.callKey;
      this.callID = call.callId;
      this.callOutID = call.callOutId;
      this.callType = call.callType;
      this.DNIS = call.numberDNIS;
      this.dataContact = call.dataContact;
      this.dataHeaders = call.dataHeaders;
      this.dataKeyValue = call.dataKeyValue;
      this.campName = call.campName;
      this.engineID = call.engineId;
      this.holdTime = call.holdTime;
      this.campID = call.idCamp;
      this.isACDTransfer = call.isACDTransfer;
      this.isQueueCall = call.isQueueCall;
      this.phone = call.phone;
      this.port = call.port;
      this.waitingTime = call.waitingTime;
      this.wrapUpTime = call.wrapUpTime;
      this.action = call.action;
      this.holdCall = call.holdCall;
    }
    getCallOutDataFromCall() {
      return {
        callKey: this.callKey,
        callID: this.callID,
        callOutID: this.callOutID,
        callType: this.callType,
        DNIS: this.DNIS,
        dataContact: this.dataContact,
        dataHeaders: this.dataHeaders,
        dataKeyValue: this.dataKeyValue,
        campName: this.campName,
        engineID: this.engineID,
        holdTime: this.holdTime,
        campId: this.campID,
        isACDTransfer: this.isACDTransfer,
        isQueueCall: this.isQueueCall,
        phone: this.phone,
        port: this.port,
        waitingTime: this.waitingTime,
        wrapUpTime: this.wrapUpTime,
        action: this.action,
        holdCall: this.holdCall,
        selectedPhoneItem: this.selectedPhoneItem,
        exitDispositionsMode: this.exitDispositionsMode,
        saveDispositionInDialog: this.saveDispositionInDialog,
        assistedCallKey: this.assistedCallKey,
        assistedData1: this.assistedData1,
        assistedData: this.assistedData
      };
    }
}